import { Avatar, Badge, Button, Icon, IconButton, Paper, Stack, styled, Typography } from '@mui/material'
import { Image } from 'mui-image'
import { useAppSelector } from '../../app/hooks'
import { ImmaginiProps } from './Immagini'
import { useImmaginiQuery } from './immaginiAPI'
import { ImmagineRequest, selectImages } from './immaginiSlice'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import { useState } from 'react'
const PREVIEW_SIZE = 80

export function ImmaginiList({ id, DOC_ID, TIPO, onPreviewClick }: ImmaginiProps) {
    const { data, error, isFetching } = useImmaginiQuery({ id, TIPO })

    const SmallAvatar = styled(Avatar)(({ theme }) => ({
        width: 20,
        height: 20,
        border: `2px solid ${theme.palette.background.paper}`,
        fontSize: 10,
        paddingTop: 3,
    }))

    const images: ImmagineRequest[] = useAppSelector(selectImages)

    const [isDownloading, setIsDownloading] = useState(false)
    const handleDownload = async (src: string, id: string) => {
        setIsDownloading(true)

        try {
            const response = await fetch(src, {
                method: 'GET',
                headers: {
                    // Aggiungi qui i tuoi header, se necessari
                    Authorization: `Bearer il_tuo_token`,
                },
            })

            if (!response.ok) {
                throw new Error("Errore durante la generazione dell'immagine")
            }

            // 1. Ottieni i dati come Blob
            const blob = await response.blob()

            // 2. Crea un URL locale per il Blob
            const url = window.URL.createObjectURL(blob)

            // 3. Simula il click per avviare il download
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `${id}.jpg`) // Nome del file
            document.body.appendChild(link)
            link.click()

            // 4. Pulisci
            if (link.parentNode) {
                link.parentNode.removeChild(link)
            }
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error('Download fallito:', error)
            // Qui potresti mostrare una notifica di errore all'utente
        } finally {
            setIsDownloading(false)
        }
    }

    return (
        <>
            <Paper
                elevation={3}
                square
                style={{
                    overflow: 'auto',
                    paddingLeft: '4px',
                    paddingBottom: '4px',
                    bottom: '0px',
                    width: '100%',
                    height: 'auto',
                    position: 'fixed',
                }}
            >
                <Stack direction="row" justifyContent="flex-start" alignItems="flex-end" spacing={1}>
                    {images.map((row: ImmagineRequest) => {
                        const url = `${process.env.REACT_APP_ENDPOINT}/image/imageBin?id=${row.id}&width=${PREVIEW_SIZE}&height=${PREVIEW_SIZE}&TIPO=${TIPO}&HASH=${row.HASH}`
                        return (
                            <div
                                key={row.id}
                                style={{ position: 'relative', display: 'inline', float: 'inline-start' }}
                            >
                                <IconButton
                                    onClick={() => {
                                        const url = `${process.env.REACT_APP_ENDPOINT}/image/imageBinFull?id=${row.id}&TIPO=${TIPO}`
                                        handleDownload(url, row.id)
                                    }}
                                >
                                    <DownloadForOfflineIcon />
                                </IconButton>
                                <Badge
                                    style={{ marginTop: 10 }}
                                    key={row.id}
                                    overlap="rectangular"
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    badgeContent={<SmallAvatar>{row.PROGR}</SmallAvatar>}
                                >
                                    <div
                                        onClick={() => {
                                            if (onPreviewClick) onPreviewClick(row)
                                        }}
                                    >
                                        <Image duration={0.3} fit="cover" src={url} />
                                    </div>
                                </Badge>
                            </div>
                        )
                    })}
                    {isFetching ? (
                        <Typography variant="subtitle1">Caricamente immagini in corso...</Typography>
                    ) : (
                        images.length === 0 && <Typography variant="subtitle1">Nessuna immagine caricata</Typography>
                    )}
                </Stack>
            </Paper>
        </>
    )
}
